import { Controller } from 'react-hook-form';
import { MultiSelect } from 'primereact/multiselect';
import { CHANNEL_OPTIONS } from '../../utils/channels';
import { DEFAULT_MESSAGE_MAX_LENGTH, SMS_MESSAGE_MAX_LENGTH } from '../../utils/messageLimits';

export default function ChannelsField({ control, broadcast, required = true }) {
  return (
    <Controller
      name="channels"
      control={control}
      rules={required ? { required: true } : undefined}
      render={({ field }) => (
        <div className="field">
          <label htmlFor={field.name}>Channels</label>
          <MultiSelect
            id={field.name}
            value={field.value}
            onChange={(e) => field.onChange(e.value)}
            options={CHANNEL_OPTIONS}
            className="w-full mb-3"
            display="chip"
            showSelectAll={false}
            disabled={!broadcast}
          />
          {!broadcast && (
            <p className="textMuted mb-3">Chat-enabled groups use Telegram as their only channel.</p>
          )}
          {broadcast && field.value?.length > 0 && (
            <p className="textMuted mb-3">
              {field.value.includes('text')
                ? `Text is enabled — messages sent to this group are limited to ${SMS_MESSAGE_MAX_LENGTH} characters (other channels allow up to ${DEFAULT_MESSAGE_MAX_LENGTH}).`
                : `Messages sent to this group are limited to ${DEFAULT_MESSAGE_MAX_LENGTH} characters.`}
            </p>
          )}
        </div>
      )}
    />
  );
}
